import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet-async";

export default function News() {
  const news = [
    {
      image: "/img/news/news1.jpg",
      title:
        "Dalai Lama felicitated with Gandhi Mandela Award for lifelong efforts to promote peace - Hindustan Times",
      link: "https://www.hindustantimes.com/cities/chandigarh-news/dalai-lama-felicitated-with-gandhi-mandela-award-for-lifelong-efforts-to-promote-peace-101668861908029.html",
    },
    {
      image: "/img/news/news2.jpg",
      title:
        "Dalai Lama conferred Gandhi Mandela Award by HP governor Rajendra Arlekar- Business-Standard",
      link: "https://www.business-standard.com/article/current-affairs/dalai-lama-conferred-gandhi-mandela-award-by-hp-governor-rajendra-arlekar-122111900538_1.html",
    },
    {
      image: "/img/news/news3.jpg",
      title:
        "Dalai Lama conferred Gandhi Mandela Award - National Herald",
      link: "https://www.nationalheraldindia.com/national/dalai-lama-conferred-gandhi-mandela-award",
    },
    {
      image: "/img/news/news4.jpg",
      title:
        "Dalai Lama receives Gandhi Mandela Award: What is this honour - Indian Express",
      link: "#",
    },
    {
      image: "/img/news/news5.jpg",
      title:
        "Dalai Lama receives Gandhi Mandela Award, says any problem can be solved through dialogue and peace -TOI",
      link: "https://timesofindia.indiatimes.com/india/dalai-lama-receives-gandhi-mandela-award-says-any-problem-can-be-solved-through-dialogue-and-peace/articleshow/95624801.cms",
    },
    {
      image: "/img/news/news6.jpg",
      title:
        "Spiritual Leader The Dalai Lama Receives First Peace Prize Awarded By Gandhi Mandela Foundation - Outlook",
      link: "https://www.outlookindia.com/national/spiritual-leader-the-dalai-lama-receives-first-peace-prize-awarded-by-gandhi-mandela-foundation-photos-238556",
    },
    {
      image: "/img/news/news7.jpg",
      title:
        "Dalai Lama Conferred With Gandhi Mandela Award- Pragativadi",
      link: "https://pragativadi.com/dalai-lama-conferred-with-gandhi-mandela-award/",
    },
    {
      image: "/img/news/news8.jpg",
      title:
        "Dalai Lama receives Gandhi Mandela Award, says any problem can be solved through dialogue and peace - The Hindu",
      link: "https://www.thehindu.com/news/national/other-states/dalai-lama-receives-gandhi-mandela-award-says-any-problem-can-be-solved-through-dialogue-and-peace/article66157001.ece",
    },
    {
      image: "/img/news/news9.jpg",
      title:
        "Gandhi Mandela Foundation honours Dalai Lama with peace prize- The Print",
      link: "#",
    },
    {
      image: "/img/news/news10.jpg",
      title:
        "Dalai Lama receives Gandhi Mandela Award, says any problem can be solved through dialogue and peace - PTI",
      link: "#",
    },
    {
      image: "/img/news/news11.jpg",
      title:
        "Dalai Lama Honored with Gandhi Mandela Award 2022-Buddhist Door",
      link: "https://www.buddhistdoor.net/news/dalai-lama-honored-with-gandhi-mandela-award-2022/",
    },
    {
      image: "/img/news/news12.jpg",
      title:
        "Gandhi Mandela Award for Dalai Lama- Tribune india",
      link: "https://www.tribuneindia.com/news/himachal/gandhi-mandela-award-for-dalai-lama-452779",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Latest News | Gandhi Mandela Foundation</title>
        <meta
          name="description"
          content="Latest Latest News coverage of Gandhi Mandela Foundation."
        />
      </Helmet>

      <Header />

      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span>/</span>
            <span>Latest News</span>
          </div>

          <h1>Latest News</h1>
        </div>
      </section>

      {/* News Section */}
      <section className="section">
        <div className="container">

          <div className="news-grid">
            {news.map((item, index) => (
              <div className="news-card" key={index}>

                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={item.image} alt={item.title} />
                </a>

                <h3>
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.title}
                  </a>
                </h3>

              </div>
            ))}
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
}